import BankAccount from "@/pages/DigitalAccount/bankAccount";
import { SubLayout } from "@/components/SubLayout";
import { Button, Drawer, Flex, Page, Typography } from "@payping/web-components";
import Capability from "@/pages/DigitalAccount/capability";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Close } from "@payping/icons";
import { DashboardRoutes } from "@/router";
import { useNavigate } from "react-router-dom";
import { closeId } from "@/assets/googleTrackIds";
import { useAsync } from "react-use";

const DigitalAccountHome = () => {
  const { t } = useAppTranslation();
  const { bankAgreement } = useAppSelector((state) => state.digitalAccount);
  const navigate = useNavigate();

  useAsync(async () => {
    if (bankAgreement.length) {
      navigate(DashboardRoutes.digitalAccount.yourAccount.url);
    }
  }, [bankAgreement]);

  return (
    <Drawer
      title={t("digitalAccount.openingBankAccount")}
      open={true}
      closable={false}
      placement={"bottom"}
      height={"100%"}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            navigate(DashboardRoutes.home.overview?.url);
          }}
          data-google-track={closeId}
        />
      }
    >
      <Page className="background--white">
        <SubLayout>
          <Flex vertical gap={64}>
            <BankAccount />
            <Flex vertical gap={32}>
              <Typography.Text className="!tw-flex !tw-justify-center" type={"secondary"}>
                {t("digitalAccount.capability.title")}
              </Typography.Text>
              <Capability />
            </Flex>
          </Flex>
        </SubLayout>
      </Page>
    </Drawer>
  );
};

export default DigitalAccountHome;
